<template>
	<div class="topbar">
		<BackLink classPrefix="topbar" />
		<router-link
			class="topbar__logo"
			:to="{name: 'model', params: {name: unit.name}}"
		></router-link>
		<router-link v-if="$route.query.role === 'admin'" :to="{name: 'admin'}">
			<button role="button" class="button partner-topbar__profile-icon">
				Panel admina
			</button>
		</router-link>
		<PartnerArea />
	</div>
</template>

<script>
import PartnerArea from './PartnerArea';
import BackLink from './BackLink';
import {mapUnitConfiguration} from '@/core/helpers/map-unit-configuration.helpers';

export default {
	name: 'Topbar',
	components: {PartnerArea, BackLink},
	computed: {
		...mapUnitConfiguration(['unit']),
	},
};
</script>
